export default "__VITE_ASSET__b669520a__"